import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { map, Subscription } from 'rxjs';
import { PraticaSection } from '../pratica/models/pratica-section';
import { PraticaProgressService } from '../_core/services/pratica-progress.service';
import { Slice } from './models/slice';

@Directive({
  selector: '[disabledSlice]',
})
export class DisabledSliceDirective implements OnInit, OnDestroy {
  @Input() disabledSlice: Slice | undefined;

  private progressSubscription?: Subscription;
  constructor(
    private elementRef: ElementRef<HTMLButtonElement>,
    private praticaProgressService: PraticaProgressService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    if (!this.praticaProgressService.isOutcome) {
      this.progressSubscription = this.praticaProgressService.progress$
        .pipe(
          map((progress) => {
            if (this.disabledSlice?.sectionPath === PraticaSection.SCORE) {
              return (
                this.praticaProgressService.scoreDisabled ||
                this.praticaProgressService.isFrozen
              );
            } else if (
              this.disabledSlice?.sectionPath ===
              PraticaSection.PRESENTATION_SHEET
            ) {
              return (
                this.praticaProgressService.presentationSheetDisabled ||
                this.praticaProgressService.isFrozen
              );
            } else {
              return this.praticaProgressService.isFrozen;
            }
          })
        )
        .subscribe((isDisabled) => {
          this.elementRef!.nativeElement.disabled = isDisabled;
        });
    }
  }

  ngOnDestroy(): void {
    this.progressSubscription?.unsubscribe();
  }
}
